import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col} from 'react-bootstrap'
import EditDownloadForm from './download-edit-form'
import BackLink from '../../../common/back-link/index'
import PageTitle from "../../../common/page-title/index";
import {getFile} from '../../../../actions/files'

class EditDownload extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount() {
    const id = +this.props.match.params.id;
    if(id){
      this.props.dispatch(getFile(id));
    }
  }

  componentWillUnmount(){
    this.props.dispatch(actions.reset('deep.admin_file.edit'));
    this.props.dispatch({type: 'CLEAR_EDIT_FILE'});
  }

  render(){
    return(
      <Grid bsClass="container" fluid className="files">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/downloads"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Edit Download</PageTitle>
          </Col>
        </Row>
        <EditDownloadForm file={this.props.file}/>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    file: state.files.file,
    fetched: state.files.fetched,
    fetching: state.files.fetching,
  };
};

export default connect(mapStateToProps)(EditDownload);



// WEBPACK FOOTER //
// ./src/components/admin/downloads/edit/index.jsx